import React from 'react';

export const Caret = () => (
    <span className="Caret">
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.333 13.667L9.667 7 3 13.667z"
                strokeWidth="2"
                fillRule="evenodd"
            />
        </svg>
    </span>
)



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/Caret/Caret.js